"use strict";
/**
 *  timeCueModule Module
 *
    Description 策划中心 指挥监测中心 稿件传播力管理 自定义稿件传播力
 *  Author: gaokaizhi 2018-5-10
 */
angular.module('planCommandMonitorCustomManuscriptPropModule', [])
    .controller('planCommandMonitorCustomManuscriptPropController', ["$scope", "$filter", "trsHttpService", "planCommandMonitorService","modalDialog",
        function($scope, $filter, trsHttpService, planCommandMonitorService,modalDialog) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化页面状态             
             */
            function initStatus() {
                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 20,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };
                $scope.status = {
                    "copyCurrPage": 1
                };
            };
            /**
             * [share description] 打开页面分享弹窗             
             */
            $scope.share = function(id) {
                planCommandMonitorService.share(id, "5", "复制链接和密码");
            };
            /**
             * [scan description] 查看稿件传播力列表标题             
             */
            $scope.scan = function(url) {
                window.open(url);
            };
            /**
             * [selectPageNum description] 单页面显示数据个数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                initData();
            };
            /**
             * [jumpToPage description] 跳转到指定页             
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                initData();
            };
            /**
             * [pageChanged description] 页面切换
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                initData();
            };

            /**
             * [del description] 标题删除 
             * @return {[type]} [description]
             */
            $scope.del = function(tid) {
                modalDialog.confirmModal("删除提示", "是否确定删除？",function() {
                    var params = {
                        modalname: "manuScriptsFuncAdd",
                        method: "delete",
                        methodname: "queryDataFromBigScreen",
                        serviceid: "mlf_bigdatascreen",
                        id: tid
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        if ("SUCCESS" == data.mapResult.status) {
                            initData();
                        };
                    });
                });
            };

            /**
             * [initData description] 查询传播力标题列表 
             * @return {[type]} [description]
             */
            function initData() {
                var params = {
                    modalname: "manuScriptsFuncAdd",
                    method: "getTitles",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.list = data.mapResult.content.content;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                });
            }
        }
    ]);